import { apiClient } from './showcaseApi';
import type {
  FeedbackCreateRequest,
  FeedbackResponse,
  FeedbackStatusPatchRequest,
  FeedbackListFilter,
  FeedbackMineListFilter,
  PageResponse,
} from '../types/feedback';

// queue #663 §UAT-2026-07-09-R663 §R663-2: catalog feedback endpoint 3종.
// showcaseApi.ts 의 apiClient(Bearer 자동 첨부 · ApiResponse 언랩 · WAF 오탐 정규화)를 그대로
// 재사용한다 — 신규 axios 인스턴스/인터셉터 0.
export const feedbackApi = {
  /** POST /api/eraf/catalog/feedback — 인증-any(guest 포함) */
  submit: (req: FeedbackCreateRequest): Promise<FeedbackResponse> =>
    apiClient
      .post<unknown, { data: FeedbackResponse }>('/catalog/feedback', req)
      .then((res) => res.data),

  /** GET /api/eraf/catalog/feedback?status=&excludeE2e=&page=&size= — ROLE_ADMIN.
   * excludeE2e 기본 true(§R684-3② — 미지정 시 서버 기본값도 true 이나 FE 는 명시 전송해 토글 반전을 보장). */
  list: (filter: FeedbackListFilter): Promise<PageResponse<FeedbackResponse>> =>
    apiClient
      .get<unknown, { data: PageResponse<FeedbackResponse> }>('/catalog/feedback', {
        params: {
          status: filter.status,
          excludeE2e: filter.excludeE2e ?? true,
          page: filter.page ?? 0,
          size: filter.size ?? 20,
          sort: 'createdAt,desc',
        },
      })
      .then((res) => res.data),

  /** GET /api/eraf/catalog/feedback/mine?page=&size= — 인증-any(본인 제출분만 · §R684-3③) */
  mine: (filter: FeedbackMineListFilter = {}): Promise<PageResponse<FeedbackResponse>> =>
    apiClient
      .get<unknown, { data: PageResponse<FeedbackResponse> }>('/catalog/feedback/mine', {
        params: {
          page: filter.page ?? 0,
          size: filter.size ?? 20,
          sort: 'createdAt,desc',
        },
      })
      .then((res) => res.data),

  /** PATCH /api/eraf/catalog/feedback/{id} — ROLE_ADMIN (RECEIVED→ANSWERED 전이만 허용 ·
   * ANSWERED 전이 시 answer 필수 · §R684-3①) */
  updateStatus: (id: number, req: FeedbackStatusPatchRequest): Promise<FeedbackResponse> =>
    apiClient
      .patch<unknown, { data: FeedbackResponse }>(`/catalog/feedback/${id}`, req)
      .then((res) => res.data),
};
